/**
 * Dinheiro digitado ↔ centavos inteiros.
 *
 * O contrato é centavo inteiro (regra 5 do CLAUDE.md); o que a pessoa digita é
 * "2.240,00". A conversão mora num lugar só para que "1.850" não vire mil
 * oitocentos e cinquenta numa tela e um real e oitenta e cinco na outra.
 */

function numeroDoTexto(texto: string): number | null {
    const limpo = texto.replace(/[^\d,.-]/g, '').trim();
    if (!limpo || limpo === '-') return null;
    /* Com vírgula, o ponto é milhar ("1.234,56"); sem vírgula, o ponto é
       decimal ("1234.56"). */
    const decimal = limpo.includes(',') ? limpo.replace(/\./g, '').replace(',', '.') : limpo;
    const n = Number(decimal);
    return Number.isFinite(n) ? n : null;
}

/** "2.240,00", "2240" ou "2240,5" viram centavos. Texto que não é valor, ou negativo, dá `null`. */
export function centavosDoTexto(texto: string): number | null {
    const n = numeroDoTexto(texto);
    return n !== null && n >= 0 ? Math.round(n * 100) : null;
}

/** Como `centavosDoTexto`, aceitando sinal — saldo inicial de cartão é negativo. */
export function centavosComSinalDoTexto(texto: string): number | null {
    const n = numeroDoTexto(texto);
    return n === null ? null : Math.round(n * 100);
}

/** Centavos para o campo de edição: "2.240,00", sem cifrão. */
export function textoDosCentavos(centavos: number): string {
    return (centavos / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Percentual digitado ("2,5" ou "2.5") para número. */
export function percentualDoTexto(texto: string): number | null {
    const n = numeroDoTexto(texto);
    return n !== null && n >= 0 ? Math.round(n * 100) / 100 : null;
}
